import React, { useState } from "react";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import CircularProgress from "@mui/material/CircularProgress";
import useMutation from "../../../../hooks/useMutation";
import { NOTIFY_CUSTOMER_SHIPMENT_MUTATION } from "../../../../constants/graphql/mutations";
import useAuth from "../../../../hooks/useAuth";

export default function OSAndDActions({ type, onBack, onNext, onClose, shipment, verticalLayout = false }) {
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuth();
  const { settings } = user.company;
  const [loading, setLoading] = useState(false);
  const [notifyCustomer] = useMutation(NOTIFY_CUSTOMER_SHIPMENT_MUTATION);

  const handleApproveAndNotify = () => {
    setLoading(true);
    notifyCustomer({
      variables: { shipmentId: shipment.id },
      onSuccess: () => {
        enqueueSnackbar(`${settings.filter_field2} notification sent successfully!`, {
          variant: "success",
        });
        setLoading(false);
        onClose();
      },
      onFailure: errors => {
        enqueueSnackbar(errors.submit || `Failed to send ${settings.filter_field2} notification`, {
          variant: "error",
        });
        setLoading(false);
        onClose();
      },
    });
  };

  return (
    <div style={{ width: verticalLayout ? "100%" : "auto" }}>
      {!verticalLayout && (
        <Button onClick={onBack} variant="outlined" sx={{ mr: 1 }} disabled={loading}>
          Back
        </Button>
      )}
      {type === "approve" ? (
        <Button
          onClick={handleApproveAndNotify}
          variant="contained"
          disabled={loading}
          fullWidth={verticalLayout}
          startIcon={loading && <CircularProgress size={20} color="inherit" />}
          sx={{ textTransform: "none" }}
        >
          Approve & Notify {settings.filter_field2}
        </Button>
      ) : (
        <Button 
          onClick={onNext} 
          variant="contained" 
          disabled={loading}
          fullWidth={verticalLayout}
          sx={{ textTransform: "none" }}
        >
          {verticalLayout ? "Next Step" : "Submit"}
        </Button>
      )}
    </div>
  );
}
